export const ExternalLinks = {
    ECOM_HELP_PAGE: 'https://euromonitor.com/euromonitor-help',
    ECOM_PRIVACY_POLICY: 'https://www.euromonitor.com/privacy-policy',
    PASSPORT_PRODUCT_PAGE: 'https://www.euromonitor.com/our-expertise/passport',
    CONSULTING_PRODUCT_PAGE: 'https://www.euromonitor.com/our-expertise/consulting',
    SUBSCRIPTION_APPS_PAGE: 'http://apps.euromonitor.com/',
};
